export enum Race {
  White = 1,
  Mixed,
  Black,
  Asian,
  Hispanic,
  NativeAmerican
}
